import React, { Children } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';


import { Carousel } from 'components/core/Carousel';
import { Image } from 'components/core/Image';

import './ResponsiveCarousel.scss';

export function ResponsiveCarousel({
	images,
	className
}) {
	return (
		<div className="carousel-container">
			<Carousel
				className={classnames('responsive-image-carousel', className)}
			>
				{!!images.length && Children.toArray(images.map((image) => (
					<Image flexImage className="carousel-image" src={image.src} />
				))) }
			</Carousel>
		</div>
	);
}

ResponsiveCarousel.propTypes = {
	className: PropTypes.string,
	images: PropTypes.arrayOf(
		PropTypes.shape({
			src: PropTypes.string.isRequired,
			alt: PropTypes.string
		})
	).isRequired
};

export default ResponsiveCarousel;
